import React, {Component} from "react"
import PropTypes from "prop-types"

import History from "@irati/utils/history"
import {H2, Body} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import workosService from "@irati/workos/services/workos"
import authentication from "@irati/auth"
import adminTracking from "@irati-tracking/admin"
import Loading from "@irati/ui/src/Loading"
import {AzureLogo, BambooHrLogo, BobLogo, GoogleLogo, MicrosoftLogo, OktaLogo, SamlLogo, WorkDayLogo} from "@irati/ui/src/Logos"
import {getOAuthSettings} from "@irati/sso/services/sso"
import {OAuthProvider} from "@irati/types"

import IntegrationCard from "../../../components/Settings/Integration/Card"
import Help from "../../../components/Settings/Integration/Help"
import {IFrameWrapper, IFrame} from "../styled"
import {SETTINGS_LOGIN_INTEGRATION, SETTINGS_LOGIN_INTEGRATION_SSO, SETTINGS_LOGIN_INTEGRATION_DSYNC} from "../../../routes/routeConfig"

const SSO_LEARN_MORE = "SSO_learnMore"
const DSYNC_LEARN_MORE = "DSYNC_learnMore"

interface Props extends InjectIntl{}

interface State {
  load: Promise<void> | null,
  organisationCreated: boolean,
  singleSignOnEnabled: boolean,
  directorySyncEnabled: boolean,
  createOrganisationSubmit: Promise<any> | null,
  singleSignOnLogos: any[],
  directorySyncLogos: any[]

}

class Integrations extends Component<Props, State> {
  state: State = {
    load: null,
    organisationCreated: false,
    singleSignOnEnabled: false,
    directorySyncEnabled: false,
    createOrganisationSubmit: null,
    singleSignOnLogos: [],
    directorySyncLogos: []
  }

  static contextTypes = {
    appPath: PropTypes.string
  }

  componentDidMount() {
    const load = workosService.getOrganisation(authentication.business().uuid).then((organisation) => {
      this.setState({
        organisationCreated: !!organisation?.organisationId,
        singleSignOnEnabled: !!organisation?.connectionId,
        directorySyncEnabled: !!organisation?.directoryId
      })
      if (!organisation?.connectionId) {
        getOAuthSettings(authentication.business().uuid, {fetchPolicy: "network-only"}).then((data) => {
          if (data.provider !== OAuthProvider.Unknown) {
            this.setState({singleSignOnEnabled: true})
          }
        })
      }
    })
    this.setState({load})
    this.setState({singleSignOnLogos: [
      <OktaLogo id="integrations-logo-okta" />,
      <AzureLogo id="integrations-logo-azure" />,
      <MicrosoftLogo id="integrations-logo-microsoft" />,
      <GoogleLogo id="integrations-logo-google" />,
      <SamlLogo id="integrations-logo-saml" />
    ]})
    this.setState({directorySyncLogos: [
      <OktaLogo id="integrations-logo-okta" />,
      <AzureLogo id="integrations-logo-azure" />,
      <BambooHrLogo id="integrations-logo-bamboohr" />,
      <BobLogo id="integrations-logo-bob" />,
      <WorkDayLogo id="integrations-logo-workday" />
    ]})
  }


  startIntegration = () => {
    if (!this.state.organisationCreated) {
      const createOrganisationSubmit = workosService.createOrganisation(authentication.business().uuid).then(() => {
        this.setState({organisationCreated: true})
      })
      this.setState({createOrganisationSubmit})
    }
  }

  toggleSSO = () => {
    adminTracking.startIntegrationsSSOJourney(SSO_LEARN_MORE)
    this.startIntegration()
    History.push({
      pathname: `${SETTINGS_LOGIN_INTEGRATION_SSO}`}, this.context)
  }

  togglePeopleDirectory = () => {
    adminTracking.startIntegrationsDSYNCJourney(DSYNC_LEARN_MORE)
    this.startIntegration()
    History.push({
      pathname: `${SETTINGS_LOGIN_INTEGRATION_DSYNC}`}, this.context)
  }

  onClickBack = () => {
    History.push({
      pathname: `${SETTINGS_LOGIN_INTEGRATION}`}, this.context)
  }

  render() {
    const {formatMessage} = this.props
    const {
      load,
      organisationCreated,
      singleSignOnEnabled,
      directorySyncEnabled,
      createOrganisationSubmit,
      singleSignOnLogos,
      directorySyncLogos} = this.state


    return <Loading load={load}>
      <H2 marginBottom={1}>
        <FormattedMessage id="admin.containers.integrations.title" />
      </H2>
      <Body marginBottom={2}>
        <FormattedMessage id="admin.containers.integrations.header.text1" />
      </Body>
      <Body marginBottom={2}>
        <FormattedMessage id="admin.containers.integrations.header.text2" />
      </Body>
      <IFrameWrapper>
        <IFrame
          title="integrationsVideo"
          src={formatMessage({id: "admin.containers.integrations.video"})}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          mozallowfullscreen
          webkitallowfullscreen />
      </IFrameWrapper>
      <Hr />
      <Flex>
        <IntegrationCard
          marginRight
          enabled={organisationCreated && singleSignOnEnabled}
          title="admin.containers.integrations.card.singleSignOn.title"
          text="admin.containers.integrations.card.singleSignOn.text"
          logos={singleSignOnLogos}
          onClick={this.toggleSSO}
          load={createOrganisationSubmit} />
        <IntegrationCard
          marginLeft
          enabled={organisationCreated && directorySyncEnabled}
          title="admin.containers.integrations.card.directorySync.title"
          text="admin.containers.integrations.card.directorySync.text"
          logos={directorySyncLogos}
          onClick={this.togglePeopleDirectory}
          load={createOrganisationSubmit} />
      </Flex>
      <Help />
    </Loading>
  }
}

export default injectIntl(Integrations)
